import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { createCn } from 'bem-react-classname';
import QRCodeStyling, { ErrorCorrectionLevel } from 'qr-code-styling-new';

import './qr.css';

const cn = createCn('qr');

interface Props {
    code: string;
    isPayDesign: boolean;
}

const AlfaPayIcon =
    'data:image/png;base64,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';

// PASSPORT-8295: если AlfaPay так и не вернется к QR, то можно будет выпилить кастомизацию
const QR: React.FC<Props> = ({ code, isPayDesign }) => {
    const AlfaPayParams = useCallback(() => {
        if (isPayDesign) {
            return {
                image: AlfaPayIcon,
                backgroundOptions: {
                    color: '#d6e6ff',
                },
                qrOptions: {
                    errorCorrectionLevel: 'Q' as ErrorCorrectionLevel,
                },
                imageOptions: {
                    hideBackgroundDots: true,
                    imageSize: 0.45,
                    margin: 0,
                },
            };
        }

        return {};
    }, [isPayDesign]);

    const ref = useRef<HTMLInputElement | null>(null);
    const qrCode = useMemo(
        () =>
            new QRCodeStyling({
                width: 500,
                height: 500,
                margin: 0,
                qrOptions: {
                    typeNumber: 0,
                    mode: 'Byte',
                    errorCorrectionLevel: 'L',
                },
                imageOptions: {
                    hideBackgroundDots: true,
                    imageSize: 0.4,
                    margin: 0,
                },
                dotsOptions: {
                    type: 'extra-rounded',
                    color: '#000000',
                },
                cornersSquareOptions: {
                    type: 'extra-rounded',
                    color: '#000000',
                },
                backgroundOptions: {
                    color: 'transparent',
                },
                ...AlfaPayParams(),
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    useEffect(() => {
        qrCode.update({
            data: code,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    useEffect(() => {
        qrCode.append(ref.current as HTMLElement);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div ref={ref} className={cn('container')} />;
};

export default QR;
